import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ValidationProvider', {
    attrs: {
      "slim": "",
      "rules": _vm.rules,
      "vid": _vm.vid,
      "name": _vm.name || _vm.label
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        errors,
        required,
        ariaInput
      }) {
        return [_c('div', {
          staticClass: "form-group",
          class: {
            'is-invalid': errors[0]
          }
        }, [_vm.label ? _c('label', {
          class: {
            'text-danger': errors[0]
          },
          attrs: {
            "for": _vm.vid || _vm.name
          },
          on: {
            "click": _vm.focus
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _c('span', [_vm._v(_vm._s(required ? '*' : ''))])]) : _vm._e(), _c('div', {
          staticClass: "position-relative rounded form-border",
          class: {
            ' overflow-hidden': _vm.isPending,
            'border-danger': errors[0]
          }
        }, [_c('select', _vm._b({
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue,
            expression: "innerValue"
          }],
          ref: "input",
          staticClass: "form-control border-0",
          class: {
            'is-invalid alert-danger': errors[0]
          },
          attrs: {
            "id": _vm.vid || _vm.name,
            "disabled": _vm.disabled
          },
          on: {
            "change": function ($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
                return o.selected;
              }).map(function (o) {
                var val = "_value" in o ? o._value : o.value;
                return val;
              });
              _vm.innerValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
            }
          }
        }, 'select', ariaInput, false), [_vm.useEmpty ? _c('option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v(_vm._s(_vm.emptyLabel))]) : _vm._e(), _vm._l(_vm.options, function (option, index) {
          return _c('option', {
            key: index,
            domProps: {
              "value": option.value != undefined && option.value != null ? option.value : option.text
            }
          }, [_vm._v(" " + _vm._s(option.text) + " ")]);
        })], 2), _c('IndeterminateProgress', {
          attrs: {
            "active": _vm.isPending
          }
        })], 1), _c('div', {
          staticClass: "invalid-feedback"
        }, [_vm._v(_vm._s(errors[0]))]), _vm.note && !errors[0] ? _c('small', {
          staticClass: "form-text text-muted"
        }, [_vm._v(_vm._s(_vm.note))]) : _vm._e()])];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };